import {createContext} from "react";

type SegmentTypeSeparatorState = {
  firstGeneralId: number | undefined;
  isBlocked: boolean;
};

export const SegmentTypeSeparatorContext = createContext<SegmentTypeSeparatorState>({
  firstGeneralId: undefined,
  isBlocked: false,
});
